import React from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./Components/LanguageContext";
import { Provider } from 'react-redux';
import store from "./appRedux/store";


export const Main = () => {
  return (
    <BrowserRouter>
    
     <LanguageProvider>
     {/* <Provider store={store}> */}
     <App />
     {/* </Provider> */}
     
     
    
     </LanguageProvider>
    </BrowserRouter>
  );
};
